module.exports = __webpack_public_path__ + "img/scapp_kana_wht.8d116d35.svg";